import Eyebrow from "../../Eyebrow";
import Reveal from "../../Reveal";
import SpotlightCard from "../../SpotlightCard";
import TechNote from "../TechNote";
import { howItWorksSections } from "../../../../content/howItWorksSections";

const LOOP_NODES = [
  { x: 45, label: "Watch" },
  { x: 180, label: "Investigate" },
  { x: 315, label: "Act" },
];

/**
 * Compact three-node "watch → investigate → act" flow, illustrating the
 * short description's own three clauses.
 * Translation: Compact three-node "watch → investigate → act" flow, illustrating the
 * short description's own three clauses.
 *
 * @returns {JSX.Element} Operating-loop diagram.
 */
const OperatingLoopViz = () => (
  <svg viewBox="0 0 360 135" fill="none" xmlns="http://www.w3.org/2000/svg">
    {LOOP_NODES.slice(0, -1).map((node, i) => (
      <line
        key={node.label}
        x1={node.x + 36}
        y1="58"
        x2={LOOP_NODES[i + 1].x - 36}
        y2="58"
        stroke="rgba(255,255,255,0.4)"
        strokeWidth="1.2"
        strokeDasharray="3 5"
      >
        <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
      </line>
    ))}

    {LOOP_NODES.map((node) => (
      <g key={node.label}>
        <circle cx={node.x} cy="58" r="36" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" />
        <text x={node.x} y="63" textAnchor="middle" fontSize="12" fontFamily="Public Sans, sans-serif" fontWeight="300" fill="rgba(255,255,255,0.85)">
          {node.label}
        </text>
      </g>
    ))}

    <text x="180" y="118" textAnchor="middle" fontSize="12" fontFamily="Public Sans, sans-serif" fontWeight="300" letterSpacing="0.04em" fill="rgba(255,255,255,0.6)">
      under strict safety rules
    </text>
  </svg>
);

/**
 * Control-plane / corporate-brain architecture explainer with a supporting
 * tile stack of the four managed capabilities.
 * Translation: Control-plane / corporate-brain architecture explainer with a supporting
 * tile stack of the four managed capabilities.
 *
 * @returns {JSX.Element} Solution section.
 */
const Solution = () => {
  const { solution, techNotes } = howItWorksSections;

  return (
    <section id="solution" className="section-block">
      <div className="section-shell">
        <div className="hiw-split">
          <Reveal variant="fade-right">
            <Eyebrow>
              {solution.eyebrowLabel}
              <TechNote>{techNotes[solution.techNote]}</TechNote>
            </Eyebrow>
            <h2 className="section-heading__title">{solution.title}</h2>
            <p className="section-heading__intro">{solution.description}</p>
            <div className="kanzi-how-viz hiw-solution-viz" aria-hidden="true">
              <OperatingLoopViz />
            </div>
            {solution.detail && <p className="hiw-detail-text">{solution.detail}</p>}
          </Reveal>

          <Reveal variant="fade-left" className="hiw-tile-stack">
            {solution.tiles.map((tile) => (
              <SpotlightCard key={tile.num} className="glass-panel hiw-tile">
                <span className="hiw-tile__num">{tile.num}</span>
                <div>
                  <strong>{tile.title}</strong>
                  <span className="hiw-tile__desc">{tile.description}</span>
                </div>
              </SpotlightCard>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Solution;
